import { render, staticRenderFns } from "./split-test.vue?vue&type=template&id=99b81302&"
import script from "./split-test.vue?vue&type=script&lang=js&"
export * from "./split-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports